import { default as content } from '../content/en'
export default function Footer() {
  return (
    <>
      {/* Global Footer */}
      <div className="footer">
        <div className="step-footer">
          <div className="column">
            <a target="_blank" href="https://maps.vodafone.co.uk/?configuration=PARTNER">{content.footer.coverage}</a>
          </div>
          <div className="column">
            <a target="_blank" href="https://www.bikermobile.com/faqs">{content.footer.faqs}</a>
          </div>
          <div className="column">
            <a target="_blank" href="https://www.bikermobile.com/contact-us">{content.footer.contact}</a>
          </div>
          <div className="social-media-links-column">
            <div className="social-media-icon">
              <svg className="social-media-svg" width="121" height="24" viewBox="0 0 15 15">
                <a href="https://www.facebook.com/people/Biker-Mobile/61579783466171/" target="_blank">
                  <defs>
                    <path id="prefix__a" d="M0 0h15v14.997H0z"></path>
                  </defs>
                  <g fill="#2A2A2A" fillRule="evenodd">
                    <path d="M-897-43H127v224H-897z" fill="#2A2A2A"></path>
                    <g>
                      <mask id="prefix__b" fill="#2A2A2A">
                        <use xlinkHref="#prefix__a"></use>
                      </mask>
                      <path
                        d="M15 7.544C15 3.378 11.642 0 7.5 0 3.358 0 0 3.378 0 7.544c0 3.766 2.743 6.887 6.328 7.453V9.725H4.424v-2.18h1.904V5.881c0-1.89 1.12-2.935 2.833-2.935.82 0 1.679.147 1.679.147v1.857h-.946c-.932 0-1.222.581-1.222 1.178v1.415h2.08l-.333 2.181H8.672v5.272C12.257 14.43 15 11.31 15 7.544"
                        fill="white"
                        mask="url(#prefix__b)"
                      ></path>
                    </g>
                    <path
                      d="M10.574 9.699l.337-2.155H8.804V6.145c0-.59.294-1.164 1.238-1.164H11V3.146S10.13 3 9.3 3C7.563 3 6.43 4.032 6.43 5.901v1.643H4.5v2.155h1.93v5.21a7.798 7.798 0 002.374 0V9.7h1.77"
                      fill="#FFFFFE"
                    ></path>
                  </g>
                </a>
              </svg>
            </div>
            <div className="social-media-icon">
              <svg className="social-media-svg" width="121" height="24" viewBox="0 0 15 15" color="#2A2A2A">
                <a href="https://x.com/BikerMobile" target="_blank">
                  <defs>
                    <path id="prefix__a" d="M0 .035h14.69v14.147H0z"></path>
                  </defs>
                  <g fill="none" fillRule="evenodd">
                    <path fill="#2A2A2A" d="M-896-2302H128V94H-896z"></path>
                    <path d="M-897-66H127v224H-897z" fill="#2A2A2A"></path>
                    <g transform="translate(0 .096)">
                      <mask id="prefix__b" fill="#fff">
                        <use xlinkHref="#prefix__a"></use>
                      </mask>
                      <path
                        d="M7.345.035c4.057 0 7.346 3.167 7.346 7.074 0 3.906-3.29 7.073-7.346 7.073S0 11.015 0 7.109C0 3.202 3.289.035 7.345.035"
                        fill="white"
                        mask="url(#prefix__b)"
                      ></path>
                    </g>
                    <path
                      d="M1.946 10.618a6.47 6.47 0 003.381.942c3.493 0 6.324-2.726 6.324-6.09a6.36 6.36 0 00-.005-.25c.126-.095.907-.698 1.099-1.086 0 0-.635.254-1.256.314h-.004l.004-.002c.057-.037.857-.561.965-1.186 0 0-.448.23-1.077.432a7.47 7.47 0 01-.325.097 2.253 2.253 0 00-1.62-.676c-1.226 0-2.219.956-2.219 2.135 0 .167.02.329.057.484-.17-.006-2.78-.147-4.554-2.217 0 0-1.06 1.394.632 2.828 0 0-.515-.02-.958-.275 0 0-.164 1.69 1.753 2.121 0 0-.377.138-.978.04 0 0 .336 1.364 2.039 1.492 0 0-1.347 1.171-3.258.897z"
                      fill="#FFF"
                    ></path>
                  </g>
                </a>
              </svg>
            </div>
            <div className="social-media-icon">
              <svg className="social-media-svg" width="121" height="24" viewBox="0 0 15 15">
                <a href="https://www.instagram.com/bikermobile/  " target="_blank">
                  <defs>
                    <path id="prefix__a" d="M0 0h15v15H0z"></path>
                  </defs>
                  <g fill="#2A2A2A" fillRule="evenodd">
                    <path fill="#2A2A2A" d="M-896-2325H128V71H-896z"></path>
                    <path d="M-897-89H127v224H-897z" fill="#2A2A2A"></path>
                    <g>
                      <mask id="prefix__b" fill="#2A2A2A">
                        <use xlinkHref="#prefix__a"></use>
                      </mask>
                      <path
                        d="M0 7.5a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0z"
                        fill="gray"
                        mask="url(#prefix__b)"
                      ></path>
                    </g>
                    <path
                      d="M7.5 2.692c-1.306 0-1.47.005-1.982.028-.512.024-.862.105-1.167.224a2.358 2.358 0 00-.852.555 2.359 2.359 0 00-.555.85c-.118.308-.2.656-.223 1.168-.024.513-.03.677-.03 1.983s.006 1.47.03 1.982c.023.512.105.862.223 1.167.123.317.287.585.555.853.267.266.535.431.852.553.305.12.655.201 1.167.224.512.024.676.03 1.982.03s1.47-.006 1.983-.03c.51-.023.86-.104 1.166-.223a2.36 2.36 0 00.852-.554c.268-.268.432-.537.555-.853.118-.305.2-.655.223-1.167.024-.512.03-.676.03-1.982s-.006-1.47-.03-1.983c-.023-.512-.105-.86-.223-1.167a2.348 2.348 0 00-.555-.851 2.364 2.364 0 00-.852-.555c-.305-.119-.655-.2-1.166-.224-.513-.023-.677-.028-1.983-.028m0 .866c1.284 0 1.436.005 1.943.028.468.021.723.1.893.165.224.088.384.192.553.36.168.168.272.329.36.553.065.17.144.424.165.893.023.507.028.66.028 1.943 0 1.284-.005 1.435-.028 1.943-.021.469-.1.723-.166.893a1.49 1.49 0 01-.36.553 1.492 1.492 0 01-.552.359c-.17.066-.425.144-.893.166-.507.023-.659.028-1.943.028s-1.436-.005-1.942-.028c-.47-.022-.725-.1-.894-.166a1.492 1.492 0 01-.553-.36 1.482 1.482 0 01-.36-.553c-.065-.169-.144-.423-.165-.892-.023-.508-.028-.66-.028-1.943 0-1.284.005-1.436.028-1.943.02-.469.1-.723.166-.893.087-.224.191-.385.36-.553.168-.168.328-.272.552-.36.17-.065.424-.144.894-.165.506-.023.658-.028 1.942-.028"
                      fill="#FFF"
                    ></path>
                    <path
                      d="M7.5 9.103a1.603 1.603 0 110-3.205 1.603 1.603 0 010 3.205m0-4.073a2.47 2.47 0 10.001 4.94 2.47 2.47 0 000-4.94M10.644 4.934a.577.577 0 11-1.154-.001.577.577 0 011.154 0"
                      fill="#FFF"
                    ></path>
                  </g>
                </a>
              </svg>
            </div>
          </div>
        </div>
        <div className="footer-copyright">
          <p>{content.common.companyTM}</p>
        </div>
      </div>
    </>
  );
}
